<template>
  <div id="home">
    <section class="intro">
      <div class="intro-slide" v-for="c in carouselToUse"
           v-bind:class="c.slug"
           v-bind:style="{ backgroundImage: 'url(/img/intro/' + c.url + ')', opacity: c.opacity }">
      </div>
    </section>

    <section class="main">
      <h1>Texas Photographer</h1>
      <h2>Elopements, Weddings, and Family Photography</h2>

      <img class="separator" src="/img/mountains-outline.svg" alt="Mountain Outline">

      <div class="quote">
        <p class="text">
          You can look at a picture for a week and never think of it again. You can also look at the picture for a
          second and think of it all your life.
        </p>

        <p class="author">- Joan Miró</p>
      </div>

      <img class="separator" src="/img/mountains-outline.svg" alt="Mountain Outline">

      <div class="text-and-image">
        <img src="/img/jovana-profile.jpg" alt="Jovana Ivic">

        <div class="text">
          <h3>
            Hey there! <br> I'm Jovana
          </h3>

          <p>
            I was born and raised in Serbia, a small country in Europe.
            I moved to the USA in 2016 and that's when I started traveling.
            One of my goals was to visit all 50 states and capture many photos of all the beautiful places in the United
            States. All that traveling started my love for landscape photography, which eventually led me to become a
            wedding, elopement and family photographer. I am currently based in Austin, TX.
          </p>

          <p>
            My focus is making you feel comfortable, relaxed, and free to be yourself.
            I want to make you feel like you really see yourself or your relationship in your photos.
            I love telling a story, capturing genuine connection and most importantly making you feel comfortable in
            front of the camera. My goal is movement and capturing those in between moments that are really you.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      interval: null,
      currentIndex: 0,
      carouselToUse: [],
      carousel: [
        {id: 1, url: '01.jpg', opacity: 0, slug: 'one'},
        {id: 2, url: '02.jpg', opacity: 0, slug: 'two'},
        {id: 3, url: '03.jpg', opacity: 0, slug: 'three'},
        {id: 4, url: '04.jpg', opacity: 0, slug: 'four'},
        {id: 5, url: '05.jpg', opacity: 0, slug: 'five'},
        {id: 6, url: '06.jpg', opacity: 0, slug: 'six'},
        {id: 7, url: '07.jpg', opacity: 0, slug: 'seven'},
        {id: 8, url: '08.jpg', opacity: 0, slug: 'eight'},
        {id: 9, url: '09.jpg', opacity: 0, slug: 'nine'},
        {id: 10, url: '10.jpg', opacity: 0, slug: 'ten'},
        {id: 11, url: '11.jpg', opacity: 0, slug: 'eleven'},
        {id: 12, url: '12.jpg', opacity: 0, slug: 'twelve'}
      ],
      phoneCarousel: [
        {id: 1, url: 'phone/01.jpg', opacity: 0, slug: 'pone'},
        {id: 2, url: 'phone/02.jpg', opacity: 0, slug: 'ptwo'},
        {id: 3, url: 'phone/03.jpg', opacity: 0, slug: 'pthree'},
        {id: 4, url: 'phone/04.jpg', opacity: 0, slug: 'pfour'},
        {id: 5, url: 'phone/05.jpg', opacity: 0, slug: 'pfive'},
        {id: 6, url: 'phone/06.jpg', opacity: 0, slug: 'psix'},
        {id: 7, url: 'phone/07.jpg', opacity: 0, slug: 'pseven'},
        {id: 8, url: 'phone/08.jpg', opacity: 0, slug: 'peight'},
        {id: 9, url: 'phone/09.jpg', opacity: 0, slug: 'pnine'},
        {id: 10, url: 'phone/10.jpg', opacity: 0, slug: 'pten'},
        {id: 11, url: 'phone/11.jpg', opacity: 0, slug: 'peleven'},
        {id: 12, url: 'phone/12.jpg', opacity: 0, slug: 'ptwelve'}
      ]
    }
  },
  methods: {
    changeSlide: function () {
      let previousIndex = this.currentIndex;

      if (this.currentIndex === this.carouselToUse.length - 1) {
        this.currentIndex = 0;
      } else {
        this.currentIndex++;
      }

      this.carouselToUse[previousIndex].opacity = 0;
      this.carouselToUse[this.currentIndex].opacity = 1;
    }
  },
  mounted() {
    let vm = this;

    window.scrollTo(0, 0);

    if (window.innerWidth > 500) {
      vm.carouselToUse = vm.carousel;
    } else {
      vm.carouselToUse = vm.phoneCarousel;
    }

    vm.currentIndex = Math.floor(Math.random() * 10);
    vm.carouselToUse[vm.currentIndex].opacity = 1;

    vm.interval = setInterval(function () {
      vm.changeSlide();
    }, 5000);
  }
}
</script>
